import {
  Badge,
  Box,
  Button,
  Collapse,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Switch,
  Tab,
} from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { Event } from '@material-ui/icons';
import CloseIcon from '@material-ui/icons/Close';
import PersonIcon from '@material-ui/icons/Person';
import {
  Alert,
  AlertTitle,
  TabContext,
  TabList,
  TabPanel,
} from '@material-ui/lab';
import {
  getAchievements,
  getCertifications,
  getCodingSkills,
  getHobbies,
  getInfosIndividual,
  getPermis,
  getProfilePreferences,
  getProfilePresentation,
  getSkillsLanguage,
  getSoftSkills,
  getSoftwareSkills,
  getStudentSkillsPro,
  getTrainings,
  getWorkExperience,
  updateProfilePreferencesIndivudual,
  updateStudentCoordonnes,
} from '@webapps/business';
import {
  FormikDatePicker,
  FormikTextField,
} from '@webapps/reactjs-tech-components';
import {
  Modal,
  useAuth,
  useMutation,
  useQuery,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import IncompleteInvisible from 'components/Icons/IncompleteInvisible';
import IncompleteProfil from 'components/Icons/IncompleteProfil';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import * as yup from 'yup';

import Achievement from './Components/Achievement';
import Certification from './Components/Certification';
import CompetenciesPerso from './Components/CompetenciesPerso';
import CompetenciesPro from './Components/CompetenciesPro';
import Criteria from './Components/Criteria';
import Description from './Components/Description';
import Education from './Components/Education';
import Experience from './Components/Experience';
import Interest from './Components/Interest';
import Language from './Components/Language';
import LanguageProg from './Components/LanguageProg';
import Permit from './Components/Permit';
import PersonalInfos from './Components/PersonalInfos';
import ProfilName from './Components/ProfilName';
import Software from './Components/Software';
import Transport from './Components/Transport';

// coverImage={dashboardInfo?.profile?.coverImageUrl}
// coverImage,

const ProfilStudent = () => {
  const { idUser } = useAuth();

  const GENDER = [
    {
      label: 'Homme',
      value: 'MALE',
    },
    {
      label: 'Femme',
      value: 'FEMALE',
    },
    {
      label: 'Non spécifié',
      value: 'NOT_SPECIFIED',
    },
  ];

  const {
    data: infos = {},
    isLoadingProfilInfo,
    refetch,
  } = useQuery(getInfosIndividual, {
    key: ['profilInfoID', idUser],
    variables: { id: idUser },
  });

  const infoSchema = yup.object().shape({
    firstname: yup.string(),
    lastname: yup.string(),
    phone: yup.string(),
    email: yup.string(),
    birthDate: yup.string(),
    gender: yup.string(),
    address: yup.object().shape({
      label: yup.string(),
      city: yup.string(),
      cityCode: yup.string(),
    }),
  });

  const formik = useFormik({
    initialValues: {
      firstname: infos?.firstname || '',
      lastname: infos?.lastname || '',
      phone: infos?.phone || '',
      email: infos?.email || '',
      birthDate: infos?.birthDate || '',
      gender: infos?.gender || '',
      address: {
        label: infos?.address?.label || '',
        city: infos?.address?.city || '',
        cityCode: infos?.address?.cityCode || '',
      },
    },
    validationSchema: infoSchema,
    enableReinitialize: true,
    onSubmit: async ({ birthDate, ...values }) => {
        await mutateUpdateCoordonnes({
          data: {
            birthDate: format(new Date(birthDate ? birthDate : new Date()), "yyyy-MM-dd'T'HH:mm:ss"),
            ...values,
          },
          id: idUser,
        });
        refetch();
    },
  });

  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const [value, setValue] = useState('1');
  const intl = useIntl();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const location = useLocation();
  const state = location.state;

  const { addToast } = useToast();

  const {
    data: skillsLanguage = [],
    refetch: refetchLang,
    isFetching: isFetchingLangage,
  } = useQuery(getSkillsLanguage, {
    key: 'skillsLanguage',
    variables: { id: idUser },
  });

  const { data: hobbies = [], refetch: refetchHobbies } = useQuery(getHobbies, {
    key: 'hobbies',
    variables: { id: idUser },
  });

  const { data: softSkills = [], refetch: refetchCompPerso } = useQuery(
    getSoftSkills,
    {
      key: 'softSkills',
      variables: { id: idUser },
    }
  );

  const { data: softwareSkills = [], refetch: refetchSoftware } = useQuery(
    getSoftwareSkills,
    {
      key: 'softwareSkills',
      variables: { id: idUser },
    }
  );

  const { data: codingSkills = [], refetch: refetchcodingSkills } = useQuery(
    getCodingSkills,
    {
      key: 'codingSkills',
      variables: { id: idUser },
    }
  );

  const {
    data: trainings = [],
    refetch: refetchTrainings,
    isFetching: isFetchingTraining,
  } = useQuery(getTrainings, {
    key: 'trainings',
    variables: { id: idUser },
  });

  const { data: certifications = [], refetch: refetchCertifications } =
    useQuery(getCertifications, {
      key: 'certifications',
      variables: { id: idUser },
    });

  const { data: achievements = [], refetch: refetchAchievements } = useQuery(
    getAchievements,
    {
      key: 'achievements',
      variables: { id: idUser },
    }
  );

  const {
    data: skillsPro = [],
    refetch: refetchSkillsPro,
    isFetching: isFetchingSkills,
  } = useQuery(getStudentSkillsPro, {
    key: 'skillsPerso',
    variables: { id: idUser },
  });

  const {
    data: workExperiences = [],
    refetch: refetchExperience,
    isFetching: isFetchingExperience,
  } = useQuery(getWorkExperience, {
    key: 'workExperiences',
    variables: { id: idUser },
  });

  const {
    data: { presentation = '', completeRate } = {},
    refetch: refetchPresentation,
  } = useQuery(getProfilePresentation, {
    key: 'studentDescription',
    variables: { id: idUser },
  });

  const { data: permis = [], refetch: refetchPermis } = useQuery(getPermis, {
    key: 'studentPermis',
    variables: { id: idUser },
  });

  const unique = [...new Set(skillsPro?.map((item) => item.category.label))];

  const newL = unique?.map((obj) => ({
    label: obj,
    skills: skillsPro?.filter(({ category }) => category.label === obj),
  }));

  const [open, setOpen] = useState(false);
  const [openPref, setOpenPref] = useState(false);
  const [openProfilIncomplete, setOpenProfilIncomplete] = useState(false);
  const [openInvisible, setOpenInvisible] = useState(false);

  const { data: preferences = {}, refetch: refetchProfilPreference } = useQuery(
    getProfilePreferences,
    {
      key: 'preferences',
      variables: { id: idUser },
    }
  );

  const [disabled, setDisabled] = useState(true);

  const {
    // error,
    isLoading: isLoadingVisibility,
    isSuccess: isScuccesVisibleCV,
    mutateAsync: mutateUpdatePreferences,
  } = useMutation(updateProfilePreferencesIndivudual);

  const {
    isLoading: isLoadingUpdate,
    isSuccess: isSuccessUpdate,
    mutateAsync: mutateUpdateCoordonnes,
  } = useMutation(updateStudentCoordonnes);

  const setVisibilityOnCV = async (id) => {
    await mutateUpdatePreferences({
      status: !preferences?.visibleOnCvLibrary,
      type: 'visible_on_cv_library',
      id,
    });
    refetchProfilPreference();
  };

  useEffect(() => {
    if (preferences.visibleOnCvLibrary === false) {
      setOpenPref(true);
    } else {
      setOpenPref(false);
    }
  }, [preferences]);

  useEffect(() => {
    if (completeRate < 100) {
      setOpen(true);
    } else if (completeRate === 100) {
      setOpen(false);
    }
  }, [completeRate]);

  useEffect(() => {
    if (state && state.modal && state.modal === 'Invisible') {
      setOpenInvisible(true);
    } else if (state && state.modal && state.modal === 'Incomplete') {
      setOpenProfilIncomplete(true);
    }
  }, []);

  useEffect(() => {
    if (isScuccesVisibleCV) {
      if (preferences?.visibleOnCvLibrary) {
        addToast({
          status: 'success',
          message: 'Non visible dans la CVthèque',
        });
      } else {
        addToast({
          status: 'success',
          message: 'Visible dans la CVthèque',
        });
      }
      setTimeout(() => {
        setOpenInvisible(false);
      }, 500);
    }
  }, [isScuccesVisibleCV]);

  const [tabOrientation, setTabOrientation] = useState('horizontal');

  useEffect(() => {
    const updateOrientation = () => {
      const newOrientation =
        window.innerWidth < 768 ? 'vertical' : 'horizontal';
      setTabOrientation(newOrientation);
    };

    window.addEventListener('resize', updateOrientation);
    updateOrientation();

    return () => window.removeEventListener('resize', updateOrientation);
  }, []);

  return (
    <>
      <div className={classes.container}>
        <Grid
          container
          className={cx(
            classes.container,
            css({
              columnGap: '30px',
              padding: '50px',
              '@media only screen and (max-width:1543px)': { padding: '42px' },
              '@media only screen and (max-width:1440px)': { padding: '34px' },
              '&::-webkit-scrollbar': {
                display: 'none',
              },
              '@media only screen and (max-width:768px)': {
                padding: '20px',
              },
            })
          )}
        >
          <Grid
            className={classes.container2}
            item
            xs={12}
            sm={12}
            md={12}
            lg={4}
            xl={4}
            style={{
              borderRadius: '12px',
              backgroundColor: '#FFFFFF',
            }}
          >
            <Grid container xs={12}>
              <Grid item xs={12}>
                <ProfilName />
              </Grid>
              <Grid item xs={12}>
                <Divider fullWidth />
              </Grid>
              <Grid item xs={12}>
                <Description
                  presentation={presentation}
                  refetch={refetchPresentation}
                />
              </Grid>
            </Grid>
            <div className={classes.buttoncontainer}>
              <Grid item xs={12} className={css({ cursor: 'pointer' })}>
                <FormikTextField
                  fullWidth
                  borderRadius={6}
                  inputProps={{
                    className: cx(
                      classes.infoBoxGender,
                      css({
                        cursor: 'pointer',
                        backgroundColor: formik?.values?.gender
                          ? '#F3F7FF'
                          : '#F50057',
                      })
                    ),
                  }}
                  completed={formik?.values?.gender}
                  variant="filled"
                  formik={formik}
                  label={<FormattedMessage id="gender" />}
                  name="gender"
                  select
                  onChange={(event) => {
                    addToast({
                      status: 'success',
                      message: 'Modification effectuée !',
                    });
                    
                    formik.setFieldValue('gender', event.target.value);
                    formik.handleSubmit();
                  }}
                  onClick={() => setDisabled(false)}
                >
                  {GENDER.map(({ label, value }, index) => (
                    <MenuItem key={index} value={value}>
                      {label}
                    </MenuItem>
                  ))}
                </FormikTextField>
              </Grid>
              <Grid item xs={12} >
                {disabled ? (
                  <FormikDatePicker
                    inputProps={{
                      className: cx(
                        classes.infoBox,
                        css({ cursor: disabled ? 'pointer' : 'default' })
                      ),
                    }}
                    completed={formik?.values?.birthDate}
                    borderRadius={6}
                    formik={formik}
                    fullWidth
                    variant="filled"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Event style={{ color: '#5D75A8' }} />
                        </InputAdornment>
                      ),
                    }}
                    onChange={(value) => {
                      addToast({
                        status: 'success',
                        message: 'Modification effectuée !',
                      });
                      formik.setFieldValue('birthDate', value);
                      formik.handleSubmit();
                    }}
                    label={<FormattedMessage id="birthDate" />}
                    name="birthDate"
                    onClick={() => {
                      setDisabled(false);
                    }}
                    onDisabledClick={() => setDisabled(false)}
                  />
                ) : (
                  <FormikDatePicker
                    inputProps={{
                      className: cx(
                        classes.infoBox,
                        css({ cursor: disabled ? 'pointer' : 'default' })
                      ),
                    }}
                    completed={formik?.values?.birthDate}
                    borderRadius={6}
                    formik={formik}
                    fullWidth
                    variant="filled"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Event style={{ color: '#5D75A8' }} />
                        </InputAdornment>
                      ),
                    }}
                    onChange={(value) => {
                      addToast({
                        status: 'success',
                        message: 'Modification effectuée !',
                      });
                      formik.setFieldValue('birthDate', value);
                      formik.handleSubmit();
                    }}
                    label={<FormattedMessage id="birthDate" />}
                    name="birthDate"
                    onClick={() => {
                      setDisabled(false);
                    }}
                    onDisabledClick={() => setDisabled(false)}
                  />
                )}
              </Grid>
            </div>
          </Grid>
          <Grid
            className={classes.container3 + ' ' + classes.flexcolumn}
            item
            xs
          >
            <TabContext value={value}>
              <div>
                <TabList
                  variant="fullWidth"
                  className={css({
                    '@media only screen and (max-width:768px)': {
                      padding: 0,
                      margin: 0,
                    },
                  })}
                  indicatorColor="default"
                  orientation={tabOrientation}
                  onChange={handleChange}
                >
                  <Tab
                    classes={{
                      root: css({
                        border: '1px solid #C0D9FF',
                        borderBottom: 0,
                        opacity: 1,
                        background: value === '1' ? 'white' : '#F3F7FF',
                        color: value === '1' ? '#152652' : '#5A6DA1',
                        fontWeight: value === '1' ? 600 : 400,
                        marginLeft: 0,
                        padding: spacing(1, 3),
                        '@media only screen and (max-width:768px)': {
                          padding: spacing(0, 2),
                          marginLeft: 0,
                        },
                      }),
                    }}
                    className={global.mainTitle}
                    label={intl.formatMessage({
                      id: 'student.profil.subMenu.apropos',
                    })}
                    value="1"
                  />
                  <Tab
                    classes={{
                      root: css({
                        border: '1px solid #C0D9FF',
                        opacity: 1,
                        borderBottom: 0,
                        marginLeft: 0,
                        background: value === '2' ? 'white' : '#F3F7FF',
                        color: value === '2' ? '#152652' : '#5A6DA1',
                        fontWeight: value === '2' ? 600 : 400,
                        padding: spacing(1, 3),
                        '@media only screen and (max-width:768px)': {
                          padding: spacing(0, 2),
                          marginLeft: 0,
                        },
                      }),
                    }}
                    className={global.mainTitle}
                    label={intl.formatMessage({
                      id: 'student.profil.subMenu.competences',
                    })}
                    value="2"
                  />
                  <Tab
                    classes={{
                      root: css({
                        border: '1px solid #C0D9FF',
                        opacity: 1,
                        borderBottom: 0,
                        marginLeft: 0,
                        background: value === '3' ? 'white' : '#F3F7FF',
                        color: value === '3' ? '#152652' : '#5A6DA1',
                        fontWeight: value === '3' ? 600 : 400,
                        padding: spacing(1, 3),
                        '@media only screen and (max-width:768px)': {
                          padding: spacing(0, 2),
                          marginLeft: 0,
                        },
                      }),
                    }}
                    className={global.mainTitle}
                    label={intl.formatMessage({
                      id: 'student.profil.subMenu.cv',
                    })}
                    value="3"
                  />
                </TabList>
              </div>
              <TabPanel
                className={css({
                  padding: 0,
                })}
                value="1"
              >
                <Grid container>
                  <Grid item xs={12}>
                    <PersonalInfos />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={12}
                    style={{ marginTop: 20 }}
                  >
                    <Criteria />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={12}
                    style={{ marginTop: 20 }}
                  >
                    <Transport />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={12}
                    style={{ marginTop: 20 }}
                  >
                    <Permit permis={permis} refetch={refetchPermis} />
                    <Interest hobbies={hobbies} refetch={refetchHobbies} />
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel
                className={css({
                  padding: 0,
                })}
                value="2"
              >
                <Grid container spacing={5}>
                  <Grid item md={12} xs={12}>
                    <CompetenciesPro
                      allSkills={newL}
                      refetch={refetchSkillsPro}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  className={css({
                    marginTop: '20px',
                  })}
                  spacing={2}
                >
                  <Grid item md={6} xs={12}>
                    <CompetenciesPerso
                      refetch={refetchCompPerso}
                      softSkills={softSkills}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <LanguageProg
                      codingSkills={codingSkills}
                      refetch={refetchcodingSkills}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <Language language={skillsLanguage} refetch={refetchLang} />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <Software
                      refetch={refetchSoftware}
                      softwareSkills={softwareSkills}
                    />
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel
                className={css({
                  padding: 0,
                })}
                value="3"
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Education
                      refetch={refetchTrainings}
                      trainings={trainings}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    style={{ marginTop: 20 }}
                  >
                    <Experience
                      refetch={refetchExperience}
                      workExperiences={workExperiences}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    style={{ marginTop: 20 }}
                  >
                    <Certification
                      certifications={certifications}
                      refetch={refetchCertifications}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Achievement
                      achievements={achievements}
                      refetch={refetchAchievements}
                    />
                  </Grid>
                </Grid>
              </TabPanel>
            </TabContext>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

const styles = ({ spacing }) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'start',
    lineHeight: '110%',
  },
  container2: {
    '@media only screen and (max-width:1280px)': {
      marginBottom: spacing(3),
    },
  },
  container3: {
    display: 'flex',
    flexDirection: 'column',
  },
  imgContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  flexcolumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  alertBox: {
    width: '100%',
    backgroundColor: '#FFF',
    border: '3px solid #0060F9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: '10px',
    padding: '10px',
    '@media only screen and (max-width:768px)': {
      width: '95%',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  alertContainer: {
    display: 'flex',
    marginLeft: spacing(3),
    justifyContent: 'start',
    alignItems: 'center',
  },
  alertInfo: {
    fontSize: '50px',
    margin: '0 20px',
  },
  alertTitle: {
    '@media only screen and (max-width:1920px)': { fontSize: '15.00px' }, '@media only screen and (max-width:1600px)': { fontSize: '14.00px' },
    marginBottom: spacing(2),
    fontFamily: 'Montserrat',
    fontWeight: 600,
  },
  alertText: {
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    marginTop: 0,
    fontFamily: 'Roboto',
    color: '#5D75A8',
  },
  collapse: {
    width: '49%',
    marginTop: spacing(1),
    marginBottom: spacing(1),
    '@media (max-width:1309px)': { width: '100%' },
  },
  modalTitle: {
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 'bold',
    color: '#152652',
    marginBottom: spacing(2),
    textAlign: 'center',
  },
  modalText: {
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    color: '#152652',
    marginBottom: spacing(2),
    textAlign: 'center',
  },
  modalList: {
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    color: '#152652',
  },
  btnCV: {
    marginLeft: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: spacing(2.5),
  },
  infoBoxGender: {
    borderRadius: '5px',
    cursor: 'pointer',
    color: '#152652',
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontFamily: 'Roboto',
    display: 'flex',
    alignItems: 'center',
    // backgroundColor: '#F3F7FF',
  },
  infoBox: {
    borderRadius: '5px',
    color: '#152652',
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontFamily: 'Roboto',
    backgroundColor: '#F3F7FF',
  },
  infoBoxDisabled: {
    borderRadius: '5px',
    color: '#5D75A8',
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontFamily: 'Roboto',
    height: '30px',
    backgroundColor: '#FFFFFF',
    WebkitTextFillColor: '#152652',
  },
  buttoncontainer: {
    display: 'flex',
    padding: '20px',
    gap: '10px',
    flexWrap: 'nowrap',
    '@media only screen and (max-width:1280px)': {
      flexWrap: 'wrap',
    }
  }
});

export default ProfilStudent;
